// extracted by extract-css-chunks-webpack-plugin
module.exports = {"min-width-0":"_3XckH"};